import { render, staticRenderFns } from "./StatCounter.vue?vue&type=template&id=100be963&scoped=true&"
import script from "./StatCounter.vue?vue&type=script&lang=js&"
export * from "./StatCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100be963",
  null
  
)

export default component.exports